export default __webpack_public_path__ + "assets/images/4826f2ea049b6130ef7a6296cc183eb9.jpg";